.item {
  box-sizing: border-box;
  background-color: inherit;
  text-decoration: none;

  &.default {
    color: var(--dds-color-text-default);
  }

  &.danger {
    color: var(--dds-color-text-danger);
  }
}

.item--interactive {
  text-align: left;
  -webkit-user-select: text;
          user-select: text;
  border: none;
  cursor: pointer;
  outline: inherit;
  width: 100%;
  @media (prefers-reduced-motion: no-preference) {
    transition: background-color var(--dds-motion-micro-state);
  }

  &:hover,
  &:active {
    background-color: var(--dds-color-surface-hover-default);
  }
}

.item--loading {
  cursor: not-allowed;
  position: relative;
}
